module.exports = __webpack_public_path__ + "img/_MG_8652.adbdba01.jpg";